"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapResult = exports.wrapResult = exports.EthereumNetworksInverted = exports.EthereumNetworks = exports.findNamingServiceName = exports.constructRecords = exports.isNullAddress = exports.hexToBytes = exports.signedLink = exports.signedInfuraLink = exports.getLibAgent = void 0;
var publicTypes_1 = require("../types/publicTypes");
var types_1 = require("../types");
var Tlds_1 = __importDefault(require("./Tlds"));
var resolutionError_1 = __importStar(require("../errors/resolutionError"));
var ProviderURLMap = {
    infura: {
        mainnet: 'https://mainnet.infura.io/v3/',
        sepolia: 'https://sepolia.infura.io/v3/',
        'polygon-mainnet': 'https://polygon-mainnet.infura.io/v3/',
        'polygon-amoy': 'https://polygon-amoy.infura.io/v3/',
        'base-mainnet': 'https://base-mainnet.infura.io/v3/',
        'base-sepolia': 'https://base-sepolia.infura.io/v3/',
    },
    alchemy: {
        mainnet: 'https://eth-mainnet.g.alchemy.com/v2/',
        sepolia: 'https://eth-sepolia.g.alchemy.com/v2/',
        'polygon-mainnet': 'https://polygon-mainnet.g.alchemy.com/v2/',
        'polygon-amoy': 'https://polygon-amoy.g.alchemy.com/v2/',
        'base-mainnet': 'https://base-mainnet.g.alchemy.com/v2/',
        'base-sepolia': 'https://base-sepolia.g.alchemy.com/v2/',
    },
};
function getLibAgent() {
    var libAgent = 'UnstoppableDomains/resolution-js';
    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        var pjson = require('../../package.json');
        libAgent += '/' + pjson.version;
        return libAgent;
    }
    catch (e) {
        return libAgent;
    }
}
exports.getLibAgent = getLibAgent;
function signedInfuraLink(infura, network) {
    if (network === void 0) { network = 'mainnet'; }
    return "https://".concat(network, ".infura.io/v3/").concat(infura);
}
exports.signedInfuraLink = signedInfuraLink;
function signedLink(key, network, provider) {
    if (network === void 0) { network = 'mainnet'; }
    if (provider === void 0) { provider = 'alchemy'; }
    var url = ProviderURLMap[provider][network];
    return "".concat(url).concat(key);
}
exports.signedLink = signedLink;
function hexToBytes(hexString) {
    var hex = hexString.replace(/^0x/i, '');
    var bytes = [];
    for (var c = 0; c < hex.length; c += 2) {
        bytes.push(parseInt(hex.substr(c, 2), 16));
    }
    return bytes;
}
exports.hexToBytes = hexToBytes;
function isNullAddress(key) {
    if (!key) {
        return true;
    }
    return Object.values(types_1.NullAddresses).includes(key);
}
exports.isNullAddress = isNullAddress;
function constructRecords(keys, values) {
    var records = {};
    keys.forEach(function (key, index) {
        records[key] =
            (values instanceof Array ? values[index] : values === null || values === void 0 ? void 0 : values[key]) || '';
    });
    return records;
}
exports.constructRecords = constructRecords;
var EnsTlds = ['eth', 'reverse'];
var findNamingServiceName = function (domain) { return __awaiter(void 0, void 0, void 0, function () {
    var tld, tldsMeta, _a, namingService, registrationBlockchain;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                tld = domain.split('.').pop();
                if (!tld) {
                    return [2 /*return*/, null];
                }
                if (EnsTlds.includes(tld)) {
                    return [2 /*return*/, publicTypes_1.NamingServiceName.ENS];
                }
                return [4 /*yield*/, Tlds_1.default.getTldsMeta()];
            case 1:
                tldsMeta = _b.sent();
                if (!tldsMeta) {
                    throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                        providerMessage: 'TLD meta is not available. Possibly failed to load supported TLDs data',
                    });
                }
                if (tld in tldsMeta) {
                    _a = tldsMeta[tld], namingService = _a.namingService, registrationBlockchain = _a.registrationBlockchain;
                    switch (namingService) {
                        case 'UNS': {
                            switch (registrationBlockchain) {
                                case publicTypes_1.BlockchainType.BASE:
                                    return [2 /*return*/, publicTypes_1.NamingServiceName.UNS_BASE];
                                default:
                                    return [2 /*return*/, publicTypes_1.NamingServiceName.UNS];
                            }
                        }
                        case 'ENS':
                            return [2 /*return*/, publicTypes_1.NamingServiceName.ENS];
                        case 'ZNS':
                            return [2 /*return*/, publicTypes_1.NamingServiceName.ZNS];
                    }
                }
                return [2 /*return*/, null];
        }
    });
}); };
exports.findNamingServiceName = findNamingServiceName;
exports.EthereumNetworks = {
    mainnet: 1,
    sepolia: 11155111,
    'polygon-mainnet': 137,
    'polygon-amoy': 80002,
    'base-mainnet': 8453,
    'base-sepolia': 84532,
};
exports.EthereumNetworksInverted = Object.entries(exports.EthereumNetworks).reduce(function (acc, _a) {
    var _b;
    var originalKey = _a[0], originalValue = _a[1];
    return (__assign(__assign({}, acc), (_b = {}, _b[originalValue] = originalKey, _b)));
}, {});
var wrapResult = function (func) {
    var callResult;
    // Catch immediately in case it's not an async call.
    try {
        callResult = func();
    }
    catch (error) {
        return Promise.resolve({ result: null, error: error });
    }
    // `Promise.resolve` will convert both promise-like objects and plain values to promises.
    var promise = callResult instanceof Promise ? callResult : Promise.resolve(callResult);
    // We wrap results and errors to avoid unhandled promise rejections in case we won't `await` every promise
    // and return earlier.
    return promise.then(function (result) { return ({ result: result, error: null }); }, function (error) { return ({ result: null, error: error }); });
};
exports.wrapResult = wrapResult;
var unwrapResult = function (wrappedResult) {
    if (wrappedResult.error !== null) {
        throw wrappedResult.error;
    }
    return wrappedResult.result;
};
exports.unwrapResult = unwrapResult;
